import { render, staticRenderFns } from "./BetaBadge.vue?vue&type=template&id=f918626c&scoped=true&"
import script from "./BetaBadge.vue?vue&type=script&lang=js&"
export * from "./BetaBadge.vue?vue&type=script&lang=js&"
import style0 from "./BetaBadge.vue?vue&type=style&index=0&id=f918626c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f918626c",
  null
  
)

export default component.exports